import Vue from "vue";
import "./config";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueMask from "v-mask";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.config.productionTip = false;

Vue.use(VueMask);

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount("#sample-request-form");
